type Site = {
  name: 'bld-app';
};

type Page = {
  /**
   * The name property defines the user-friendly name of each page on the site.
   */
  name: string;
  /**
   * The detail property defines a more unique value for a given page, where necessary. If a page has multiple content tabs, and each tab should trigger virtual page view tracking, detail should be populated with the tab name.
   */
  detail?: string;
  /**
   * This property describes the top-level site section of each page.Logic in Launch automatically builds a page.section for each page, but this can be overridden in the data layer if needed—for instance, for pages built within a single page application framework for which the URL is not reliable or meaningful.
   */
  section?: string;
  /**
   * language will be used to track the content language of the page.
   */
  language: string;
  /**
   * country will be used to track the country of the page belongs to. For any page for which the first subdirectory does not appear on that list, the page is considered to be part of Global. Note that the abbreviation for Global is "glo".
   */
  country: string;
  /**
   * This property should have the full URL of the page (location.href format).for single page applications in particular, where use of hash / push state changes are utilized, often times there are timing issues with referencing location.href , depending on when the hash / push state actually occurs vs. other tags firing.  Explicitly setting this property with the intended target URL will solve for these timing issues.
   */
  url: string;
  /**
   * This property should have the full referring URL of the page (document.referrer format).
   */
  referrer?: string;
  /**
   * This property signifies the AEM page template used for a page
   */
  template?: string;
};

type User = {
  loginStatus: 'yes' | 'no';
};

type Application = 'app-editor' | 'cloud-editor' | 'build-ui' | 'common';

export type ApplicationPart = `${Application}.${any}`;
export type ActivityMapRegion = `sba.${ApplicationPart}`;
export type ActivityMapLink = string;

export type ActivityMap = {
  region: ActivityMapRegion;
  link: ActivityMapLink;
  destination?: string;
};

export enum AdobeDataLayerEvent {
  GLOBAL_DATA_LAYER = 'globalDL',
  PAGE_VIEW = 'pageView',
  ACTIVITY_MAP = 'activityMap',
  SITE_TRACK_BEACON = 'stBeaconReady',
  SITE_TRACK_LINK_BEACON = 'stlBeaconReady',
}

export type AdobeData = {
  event: AdobeDataLayerEvent;
  page?: Page;
  site?: Site;
  activityMap?: ActivityMap;
  user?: User;
};

export type AdobeDataLayer = {
  push: (event: AdobeData) => number;
  getState: () => {
    exit: { link: string };
    page: Page;
    site: Site;
    user: User;
  };
  length: number;
};

export interface EventQueueInterface extends AdobeDataLayer {
  convertToSink(): void;
  setEmpty(): void;
  shift(): AdobeData | undefined;
}
